import { RootState } from '../../store';

export const getPrioritiesSelector = (state: RootState) => state?.priorityReducer?.priorities;
